import type { Identifier } from "ra-core";

import { ClientNotes } from "./ClientNotes";
import { useClientNotes } from "./useClientNotes";

/** Team notes block for a client's panel. */
export const ClientNotesSection = ({
  contactId,
}: {
  contactId: Identifier;
}) => {
  const { notesOf, refetch } = useClientNotes([contactId]);
  return (
    <section>
      <ClientNotes
        key={String(contactId)}
        contactId={contactId}
        notes={notesOf(contactId)}
        onChanged={refetch}
      />
    </section>
  );
};
